<script>
  import ArrowDown from '@/assets/arrow-down.svg';

  export default {
    components: {
      ArrowDown,
    },

    props: {
      negative: {
        type: Boolean,
        required: false,
        default: false,
      },

      size: {
        type: Number,
        required: false,
        default: 10,
      },

      withSum: {
        type: Boolean,
        required: false,
        default: false,
      },
    },

    computed: {
      title () {
        return this.negative
          ? 'Venda'
          : 'Compra';
      },

      items () {
        const items = [];

        for (let i = 0; i < this.size; i++) {
          const percent = Math.floor(Math.random() * 100);

          items.push([
            0.0345667, 'R$ 1.345,56', 'R$ 21.629,00', percent, 'R$ 21.629,00',
          ]);
        }

        return items;
      },
    },
  };
</script>

<template>
  <section class="transaction-order-table transaction-table">
    <h2 class="transaction-table__title" v-text="title"></h2>
    <table>
      <thead>
        <tr>
          <th v-tooltip="'Quantidade'">Qtd.</th>
          <th v-tooltip="'Preço Unitário'">P. Unitário</th>
          <th>Valor Total</th>
          <th v-if="withSum">
            <span class="transaction-order-table__select">
              SUM
              <select
                class="transaction-order-table__control"
                >
                <option value="REAL" selected>R$</option>
                <option value="BTC">BTC</option>
              </select>

              <ArrowDown class="transaction-order-table__arrow" />
            </span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr :key="index" v-for="([ quantity, unity, total, percent, sum ], index) in items">
          <td>
            <span
              v-tooltip="`Quantidade: <span>${percent}%</span>`"
              >
              {{ quantity }}

              <span
                :style="{ width: `${percent}%` }"
                class="transaction-order-table__percent"
                :class="{ 'transaction-order-table__percent--negative': negative }"
                >
              </span>
            </span>
          </td>
          <td v-text="unity"></td>
          <td v-text="total"></td>
          <td v-if="withSum" v-text="sum"></td>
        </tr>
      </tbody>
    </table>
  </section>
</template>

<style lang="scss">
  .transaction-order-table {
    &__percent {
      left: 0;
      bottom: -3px;
      position: absolute;
      border-bottom: 2px solid #60c100;

      &--negative {
        border-color: #ff001f;
      }
    }

    &__select {
      position: relative;
    }

    &__control {
      cursor: pointer;
      font-size: 12px;
      color: #b2b8c5;
      padding: 3px 4px;
      appearance: none;
      border-radius: 4px;
      padding-right: 15px;
      letter-spacing: .24px;
      background: transparent;
      border: solid 1px #FFF;
    }

    &__arrow {
      top: 2px;
      right: 4px;
      width: 11px;
      height: 11px;
      position: absolute;
      pointer-events: none;
      color: #FFF !important;
    }
  }
</style>

